import { 
  Calculator, 
  Clock, 
  FileText, 
  Zap, 
  Camera, 
  Download, 
  Smartphone,
  Shield,
  Cloud,
  PenTool
} from 'lucide-react';

export const testimonials = [
  {
    name: "Mike Rodriguez",
    role: "Interior Painting, Miami FL",
    quote: "I lost 3 jobs last month because I was too slow with quotes. Switched to QuoteSnapp and closed 2 jobs the same day I sent estimates. Paid for itself in 48 hours.",
    location: "Miami, FL",
    jobsWon: 12
  },
  {
    name: "Sarah Chen",
    role: "Cabinet Resurfacing, Austin TX",
    quote: "My quotes used to look like chicken scratch on notebook paper. Now I send professional PDFs that make me look like a $500k/year operation. My close rate went from 40% to 73%.",
    location: "Austin, TX",
    jobsWon: 18
  },
  {
    name: "James Thompson",
    role: "General Contractor, Denver CO",
    quote: "I was doing quotes on Excel and it took 30+ minutes per job. Now it's 90 seconds. I can quote 10 jobs in the time it used to take me to do one. That's 10x more opportunities.",
    location: "Denver, CO",
    jobsWon: 24
  }
];

export const features = [
  {
    icon: Clock,
    title: "90-Second Quotes",
    description: "Your competitor takes 30 minutes. You take 90 seconds. First to respond wins the job. Every single time.",
    color: "bg-blue-600"
  },
  {
    icon: Calculator,
    title: "Never Undercharge Again",
    description: "Smart pricing engine calculates materials + labor + markup automatically. Stop leaving money on the table.",
    color: "bg-green-600"
  },
  {
    icon: FileText,
    title: "Look Professional. Win More.",
    description: "Branded PDFs that make you look like you run a $500k operation, not a guy with a truck and a dream.",
    color: "bg-purple-600"
  },
  {
    icon: Camera,
    title: "Photo Documentation",
    description: "Attach before/after photos directly to quotes. Show clients exactly what they're paying for.",
    color: "bg-orange-600"
  },
  {
    icon: Cloud,
    title: "Works Offline",
    description: "Generate quotes in basements, job sites, dead zones. No internet? No problem.",
    color: "bg-cyan-600"
  },
  {
    icon: PenTool,
    title: "Close On-Site",
    description: "Capture client signature before you leave. No follow-ups, no waiting, no lost deals.",
    color: "bg-pink-600"
  },
  {
    icon: Zap,
    title: "Pre-Built Templates",
    description: "One tap for common jobs: interior paint, exterior, cabinets, drywall. Your rates, saved forever.",
    color: "bg-indigo-600"
  },
  {
    icon: Download,
    title: "Instant Delivery",
    description: "Text or email quotes in seconds. Client gets it before you're back in your truck. Speed wins jobs.",
    color: "bg-teal-600"
  },
  {
    icon: Shield,
    title: "Quote History",
    description: "Every quote saved and backed up. See what you quoted, what you won, what made you money.",
    color: "bg-red-600"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    icon: Smartphone,
    title: "Input Job Details",
    description: "Customer name, project type, square footage. Takes 20 seconds while you're standing with the client."
  },
  {
    step: 2,
    icon: Calculator,
    title: "Auto-Calculate",
    description: "Smart engine handles all math. Applies your rates, calculates materials, adds markup. Zero mistakes."
  },
  {
    step: 3,
    icon: Download,
    title: "Send & Win",
    description: "Download PDF or text it to the client. They have it before you leave. You win because you're faster."
  }
];

export const stats = [
  {
    value: "1,847",
    label: "Contractors Using QuoteSnapp"
  },
  {
    value: "23,419",
    label: "Quotes Generated This Month"
  },
  {
    value: "87 sec",
    label: "Average Quote Time"
  },
  {
    value: "68%",
    label: "Average Close Rate"
  }
];

export const trustIndicators = [
  {
    metric: "$4.2M",
    label: "In jobs quoted this month"
  },
  {
    metric: "73%",
    label: "Average contractor close rate"
  },
  {
    metric: "2.3x",
    label: "Faster than competitors"
  }
];

export const socialProof = [
  "Featured on ContractorDaily",
  "Used by pros in 47 states",
  "4.9/5 rating from 1,200+ contractors"
];